import { useState, useEffect, useContext, useMemo, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import SuiBox from "components/SuiBox";
import SuiInput from "components/SuiInput";

import Card from "@mui/material/Card";

import toast from "react-hot-toast";
import moment from "moment";

import Prompt from "components/UpStyled/Prompt";
import api from "services/api";
import { nanoid } from "nanoid";

import Checkbox from "@mui/material/Checkbox";
import SuiButton from "components/SuiButton";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import SuiTypography from "components/SuiTypography";

import ClearIcon from "@mui/icons-material/Clear";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const SketchDropDownMenu = ({ sketch = {}, size = 80, onClick = () => {}, sketchOptions = [] }) => {
  const [changeSketchVisible, setChangeSketchVisible] = useState(null);

  const handleCloseChangeSketchMenu = () => setChangeSketchVisible(false);
  const SketchMenu = () => (
    <Menu
      id="calendar-action-menu"
      anchorEl={changeSketchVisible}
      open={Boolean(changeSketchVisible)}
      onClose={handleCloseChangeSketchMenu}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
    >
      <SuiBox sx={{ px: 1, maxWidth: 520, display: "flex", flexWrap: "wrap" }}>
        {sketchOptions.map((item) => (
          <Tooltip title={item?.name}>
            <div
              onClick={() => {
                handleCloseChangeSketchMenu();
                onClick(item);
              }}
              style={{
                cursor: "pointer",
              }}
            >
              <SuiBox
                width={size}
                minWidth={size}
                height={size}
                component={"img"}
                src={item?.src}
                sx={{
                  borderRadius: 1,
                  transition: "transform .2s",
                  "&:hover": {
                    transform: `scale(1.2)`,
                  },
                  filter: "invert(1)",
                  "-webkit-filter": "invert(1)",
                  mr: 0.5,
                }}
              />
              <SuiTypography
                sx={{
                  width: size,
                  minWidth: size,
                  mx: "auto",
                  pt: 0.5,
                  textAlign: "center",
                }}
              >
                {item.name}
              </SuiTypography>
            </div>
          </Tooltip>
        ))}
        <Tooltip title={"Automatically match"}>
          <div
            onClick={() => {
              handleCloseChangeSketchMenu();
              onClick(null);
            }}
            style={{
              cursor: "pointer",
            }}
          >
            <SuiBox
              sx={{
                width: size,
                height: size,
                transition: "transform .2s",
                "&:hover": {
                  transform: `scale(1.2)`,
                },

                mr: 0.5,
              }}
              color="error"
            >
              <ClearIcon sx={{ width: "100%", height: "100%", p: 2 }} />
            </SuiBox>
            <SuiTypography
              sx={{
                width: size,
                minWidth: size,
                mx: "auto",
                pt: 0.5,
                textAlign: "center",
              }}
            >
              Clear
            </SuiTypography>
          </div>
        </Tooltip>
      </SuiBox>
    </Menu>
  );

  return (
    <SuiBox>
      {sketch?.src ? (
        <div>
          <SuiBox
            minWidth={70}
            width={70}
            height={70}
            component={"img"}
            src={sketch?.src}
            sx={{
              borderRadius: 1,
              cursor: "pointer",
              filter: "invert(1)",
              "-webkit-filter": "invert(1)",
            }}
            onClick={(e) => (onClick ? setChangeSketchVisible(e.target) : null)}
          />
          <SuiTypography
            sx={{
              width: "100%",
              mx: "auto",
              textAlign: "center",
            }}
          >
            {sketch.name}
          </SuiTypography>
        </div>
      ) : (
        <SuiButton
          variant="text"
          color="info"
          size="small"
          sx={{ px: 0 }}
          onClick={(e) => (onClick ? setChangeSketchVisible(e.target) : null)}
        >
          Customize
          <ArrowDropDownIcon sx={{ height: 30, width: 30, pb: 0.5 }} />
        </SuiButton>
      )}
      <SketchMenu />
    </SuiBox>
  );
};

export default SketchDropDownMenu;
